import { createFileRoute, notFound, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { Trash2 } from "lucide-react";
import { ProductForm } from "@/components/admin/product-form";
import { adminProductQuery, adminDeleteProduct } from "@/lib/admin/admin.functions";

export const Route = createFileRoute("/admin/produtos/$id")({
  loader: async ({ context, params }) => {
    const product = await context.queryClient.ensureQueryData(adminProductQuery(params.id));
    if (!product) throw notFound();
    return product;
  },
  component: EditarProdutoPage,
});

function EditarProdutoPage() {
  const product = Route.useLoaderData();
  const navigate = useNavigate();
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    if (!window.confirm(`Excluir "${product.name}" permanentemente?`)) return;
    setDeleting(true);
    await adminDeleteProduct({ data: product.id });
    navigate({ to: "/admin/produtos" });
  };

  return (
    <div>
      <div className="mb-6 flex items-center justify-between">
        <h1 className="font-display text-2xl font-bold text-eg-dark">Editar Produto</h1>
        <button
          type="button"
          onClick={handleDelete}
          disabled={deleting}
          className="inline-flex items-center gap-2 rounded-md border border-red-600 px-4 py-2 text-sm font-semibold text-red-600 hover:bg-red-600 hover:text-white disabled:opacity-60 transition-colors"
        >
          <Trash2 className="h-4 w-4" />
          Excluir
        </button>
      </div>
      <ProductForm product={product} />
    </div>
  );
}
